import { Link } from "react-router-dom";
import type { SessionWithRelations } from "../lib/types";
import { fmtTimeRange } from "../lib/format";

interface Props {
  session: SessionWithRelations;
  to: string;
  /** participant ids of the current parent's kids that are booked into this session */
  bookedParticipantNames?: string[];
}

export function SessionCard({ session, to, bookedParticipantNames }: Props) {
  const at = session.activity_type;
  const activeBookings = session.bookings.filter((b) => b.status !== "cancelled");
  const taken = activeBookings.length;

  return (
    <Link to={to} className="card block active:scale-[0.99] transition">
      <div className="flex items-baseline justify-between gap-3">
        <div className="font-semibold text-base">
          <span className="mr-1">{at?.emoji}</span>{at?.name}
        </div>
        <div className="text-tg-hint text-sm tabular-nums">
          {fmtTimeRange(session.starts_at, session.ends_at)}
        </div>
      </div>
      {session.location_text && (
        <div className="text-tg-hint text-sm mt-1">📍 {session.location_text}</div>
      )}
      <div className="text-tg-hint text-sm mt-1">Тренер: {session.trainer.name}</div>
      <div className="mt-3 flex flex-wrap gap-1.5">
        <span className="chip">{taken}/{session.capacity}</span>
        {bookedParticipantNames?.map((n) => (
          <span key={n} className="chip bg-tg-button text-tg-buttonText">{n} ✓</span>
        ))}
      </div>
    </Link>
  );
}
